export default __webpack_public_path__ + "static/media/logo-collapsed.009947d9.svg";